var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FFFA605C-5101-490B-BF7C-4995DF516FA4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-login",
    transform: "translate(-785, -481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(785, 481)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3874362,6 C18.1864261,6 22.8874362,12 22.8874362,12 C22.8874362,12 18.1864261,18 12.3874362,18 C6.58844635,18 2,12 2,12 C2,12 6.58844635,6 12.3874362,6 Z M12.3874362,8 C10.37824,8 8.28695139,8.94436644 6.2697127,10.5607563 C5.82780178,10.9148543 5.40956559,11.285444 5.01882782,11.662278 L4.678,11.999 L5.01882782,12.337722 C5.27931967,12.5889447 5.55203303,12.8373921 5.83583498,13.080028 L6.2697127,13.4392437 C8.28695139,15.0556336 10.37824,16 12.3874362,16 C14.4011317,16 16.5185849,15.0518509 18.5728196,13.4301944 C19.0227477,13.0750116 19.4492049,12.7033184 19.8481952,12.3253644 L20.181,12 L19.8481952,11.6746356 C19.5822017,11.4226663 19.3040006,11.1734795 19.0147761,10.9301122 L18.5728196,10.5698056 C16.5185849,8.94814911 14.4011317,8 12.3874362,8 Z",
    id: "Oval",
    fill: "#CEFAB7",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,7 C15.2614237,7 17.5,9.23857625 17.5,12 C17.5,14.7614237 15.2614237,17 12.5,17 C9.73857625,17 7.5,14.7614237 7.5,12 C7.5,9.23857625 9.73857625,7 12.5,7 Z M12.5,9 C10.8431458,9 9.5,10.3431458 9.5,12 C9.5,13.6568542 10.8431458,15 12.5,15 C14.1568542,15 15.5,13.6568542 15.5,12 C15.5,10.3431458 14.1568542,9 12.5,9 Z",
    id: "Oval",
    fill: "#CEFAB7",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.0abb968363f35464fff62baf02d1f5e1.svg";
export { ForwardRef as ReactComponent };